import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/accounting/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

/**
 * The accounts a payment can be registered against, for every module that
 * registers one. Ventas and Compras are deliberately absent from the
 * accounting module and get 403 from its own endpoints; this one is guarded
 * by PaymentDestinationPermission instead.
 */
const paymentService = {
  listPayableAccounts: () => {
    return axios.get(`${BASE_URL}payable-accounts/`, { headers: getHeaders() });
  }
};

export default paymentService;
